let code = 'pugestao';
let codeAPI = 'pu';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};